/**
 * 最終 ZIP 生成 (JSZip)。
 * filename → Blob のマップ + captions.csv を格納。
 */

import JSZip from 'jszip';

import type { CaptionEntry } from '../caption';

export interface ZipEntryBlob {
  readonly filename: string;
  readonly blob: Blob;
}

/**
 * @param outputs  CaptionEntry と対応する Blob の配列 (順序一致)
 * @param csvBlob  captions.csv (UTF-8 BOM 付き)
 */
export async function buildZipBlob(outputs: readonly ZipEntryBlob[], csvBlob: Blob): Promise<Blob> {
  if (outputs.length === 0) {
    throw new Error('buildZipBlob: no outputs to zip');
  }
  const zip = new JSZip();
  for (const entry of outputs) {
    zip.file(entry.filename, entry.blob);
  }
  zip.file('captions.csv', csvBlob);
  const blob = await zip.generateAsync({ type: 'blob', compression: 'STORE' });
  return new Blob([blob], { type: 'application/zip' });
}

/**
 * entries と blob マップから順序付き出力配列を作る。
 * @param entries generateCaptions の結果 (出力順)
 * @param getBlob filename → Blob を返す関数
 */
export function assembleOutputs(
  entries: readonly CaptionEntry[],
  getBlob: (entry: CaptionEntry) => Blob | undefined,
): readonly ZipEntryBlob[] {
  const outputs: ZipEntryBlob[] = [];
  for (const entry of entries) {
    const blob = getBlob(entry);
    if (!blob) continue;
    outputs.push({ filename: entry.filename, blob });
  }
  return outputs;
}

export { zipNameFor };

function zipNameFor(model: string, year: number): string {
  const safeModel = model.replace(/[\s/\\]+/g, '_').replace(/[^\w\-_.]/g, '_') || 'vehicle';
  return `${safeModel}_${year}.zip`;
}
